export default "/_next/static/chunks/fonts/LarsseitLight-4f89d5604bcad7d3c01b2f46d9329789.ttf";